import { faCreditCard } from "@fortawesome/free-regular-svg-icons";
import {
  faDrumstickBite
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { language } from "../../language/Language";

const FeatureCard = ({ icon, title, description }) => {
  return (
    <div
      className="rounded-xl group p-8 text-center hover:bg-white hover:text-gray-800 hover:shadow-xl transition duration-300"
      style={{ color: "var(--features-text-color, #ffffff)" }}
    >
      <FontAwesomeIcon className="mb-5" size="2xl" icon={icon} />
      <h3 className="text-xl font-semibold mb-3">{title}</h3>
      <p className="text-sm" style={{ color: "var(--features-text-color, #ffffff)", opacity: 0.85 }}>
        {description}
      </p>
    </div>
  );
};

const Features = () => {
  const featuresContent = {
    ar: {
      // heading: "لماذا تختار Meat House El-Fardos ؟",
      // description:
      //   "لأننا بنقدملك أجود أنواع اللحوم والمجمدات والصوصات واطباق مميزه ، مع خدمة توصيل سريعة ومريحة لحد باب بيتك.",
      features: [
        {
          icon: faDrumstickBite,
          title: "لماذا تختار Meat House El-Fardos",
          description:
            "لأننا بنقدملك أجود أنواع اللحوم والمجمدات والصوصات واطباق مميزه ، مع خدمة توصيل سريعة ومريحة لحد باب بيتك.",
        },
        {
          icon: faCreditCard,
          title: "خيارات دفع متعدده",
          description:
            "دفع كاش - انستاباى instapay - محفظة الكترونية - Valu فاليو - دفع فيزا",
        },
      ],
    },
    en: {
      // heading: "Why Choose Meat House El-Fardos?",
      // description:
      //   "Because we offer you the finest meats, frozen goods, sauces, and special dishes, with fast and convenient delivery right to your doorstep.",
      features: [
        {
          icon: faDrumstickBite,
          title: "Why Choose Meat House El-Fardos",
          description:
            "Because we offer you the finest meats, frozen goods, sauces, and special dishes, with fast and convenient delivery right to your doorstep.",
        },
        {
          icon: faCreditCard,
          title: "Multiple Payment Options",
          description:
            "Cash payment - Instapay - E-wallet - Valu - Visa payment",
        },
      ],
    },
  };

  const currentLanguage = language === "ar" ? "ar" : "en";
  const content = featuresContent[currentLanguage];

  return (
    <section
      className={`font-[sans-serif] py-16`}
      style={{background: "var(--features-bg-color, linear-gradient(to right, #f17e6e, #cb2914))"}}
    >
      <div className="container mx-auto px-4">
        {/* <h2 className="text-white sm:text-4xl text-3xl font-bold text-center mb-4">
          {content.heading}
        </h2> */}
        {/* <p className="text-white text-center mb-12">{content.description}</p> */}
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {content.features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
